var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transactions-table-card',{attrs:{"user-transactions-tab":"","operatorUserIdProps":_vm.operatorUserId,"operatorUserCreatedAtProps":_vm.operatorUserCreatedAt}})}
var staticRenderFns = []

export { render, staticRenderFns }